// Hero Date Pickers
export const HeroDatePicker = () => {
    // Verificar se Flatpickr está disponível
    if (typeof flatpickr === 'undefined') {
        console.warn('Flatpickr não está carregado');
        return;
    }

    // Configurações básicas para o Flatpickr
    const fpConfig = {
        locale: 'pt',
        dateFormat: 'd-m-Y',
        minDate: 'today',
        disableMobile: 'true',
        animate: true,
        shorthandCurrentMonth: true,
        showMonths: 1,
        // Configurar para mostrar apenas a primeira letra dos dias da semana
        onReady: function(selectedDates, dateStr, instance) {
            // Modificar os dias da semana para mostrar apenas a primeira letra
            updateWeekdayLetters(instance);
        },
        onMonthChange: function(selectedDates, dateStr, instance) {
            // Garantir que os dias da semana continuem com apenas a primeira letra ao mudar de mês
            setTimeout(() => {
                updateWeekdayLetters(instance);
            }, 0);
        },
        onYearChange: function(selectedDates, dateStr, instance) {
            // Garantir que os dias da semana continuem com apenas a primeira letra ao mudar de ano
            setTimeout(() => {
                updateWeekdayLetters(instance);
            }, 0);
        },
        onChange: function(selectedDates, dateStr, instance) {
            // Formatar data com zeros à esquerda (dd-mm-yyyy)
            if (selectedDates.length > 0) {
                const date = selectedDates[0];
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                instance.input.value = `${day}-${month}-${year}`;
            }
            
            // Atualizar data mínima do check-out
            const checkoutInput = document.getElementById('checkout-date');
            if (checkoutInput && checkoutInput._flatpickr) {
                checkoutInput._flatpickr.set('minDate', selectedDates[0] || 'today');
            }
        }
    };

    // Função para atualizar as letras dos dias da semana
    function updateWeekdayLetters(instance) {
        const weekdayElements = instance.calendarContainer.querySelectorAll('.flatpickr-weekday');
        const weekdayLetters = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];
        
        weekdayElements.forEach((el, index) => {
            if (index < weekdayLetters.length) {
                el.textContent = weekdayLetters[index];
                el.style.width = '20px';
                el.style.overflow = 'hidden';
                el.style.textOverflow = 'clip';
                el.style.whiteSpace = 'nowrap';
            }
        });
    }

    // Inicializar Check-in
    const checkinInput = document.getElementById('checkin-date');
    if (checkinInput) {
        flatpickr(checkinInput, fpConfig);
    }

    // Inicializar Check-out
    const checkoutInput = document.getElementById('checkout-date');
    if (checkoutInput) {
        flatpickr(checkoutInput, fpConfig);
    }
};

// Quartos e Hóspedes Dropdown Counter
export const QuartosHospedesCounter = () => {
    let quartos = 1;
    let adultos = 1;
    let criancas = 0;
    let isOpen = false;

    // Elementos do dropdown
    const trigger = document.getElementById('quartos-hospedes-trigger');
    const dropdown = document.getElementById('quartos-hospedes-dropdown');
    const arrow = document.getElementById('dropdown-arrow');
    const text = document.getElementById('quartos-hospedes-text');

    // Valores
    const quartosValue = document.getElementById('quartos-value');
    const adultosValue = document.getElementById('adultos-value');
    const criancasValue = document.getElementById('criancas-value');

    // Botões dos quartos
    const quartosMinus = document.getElementById('quartos-minus');
    const quartosPlus = document.getElementById('quartos-plus');

    // Botões dos adultos
    const adultosMinus = document.getElementById('adultos-minus');
    const adultosPlus = document.getElementById('adultos-plus');

    // Botões das crianças
    const criancasMinus = document.getElementById('criancas-minus');
    const criancasPlus = document.getElementById('criancas-plus');

    // Função para atualizar o texto
    const updateText = () => {
        const quartosText = quartos === 1 ? 'Quarto' : 'Quartos';
        const totalHospedes = adultos + criancas;
        const hospedesText = totalHospedes === 1 ? 'hóspede' : 'hóspedes';
        
        let textoCompleto = `${quartos} ${quartosText}, ${totalHospedes} ${hospedesText}`;
        
        // Adicionar detalhes se houver crianças
        if (criancas > 0) {
            const adultosText = adultos === 1 ? 'adulto' : 'adultos';
            const criancasText = criancas === 1 ? 'criança' : 'crianças';
            textoCompleto += ` (${adultos} ${adultosText}, ${criancas} ${criancasText})`;
        }
        
        text.textContent = textoCompleto;
    };

    // Função para atualizar valores e estados dos botões
    const updateValues = () => {
        // Atualizar valores exibidos
        quartosValue.textContent = quartos;
        adultosValue.textContent = adultos;
        criancasValue.textContent = criancas;
        
        // Atualizar estado dos botões de quartos
        if (quartosMinus) quartosMinus.disabled = quartos <= 1;
        if (quartosPlus) quartosPlus.disabled = quartos >= 10;
        
        // Atualizar estado dos botões de adultos
        if (adultosMinus) adultosMinus.disabled = adultos <= 1;
        if (adultosPlus) adultosPlus.disabled = adultos >= 20;
        
        // Atualizar estado dos botões de crianças
        if (criancasMinus) criancasMinus.disabled = criancas <= 0;
        if (criancasPlus) criancasPlus.disabled = criancas >= 10;
        
        updateText();
    };

    // Função para toggle do dropdown
    const toggleDropdown = () => {
        isOpen = !isOpen;
        
        if (isOpen) {
            // Calcular posição do dropdown
            const triggerRect = trigger.getBoundingClientRect();
            const dropdownWidth = 320; // w-80 = 20rem = 320px
            
            // Posicionar o dropdown abaixo do trigger
            dropdown.style.position = 'fixed';
            dropdown.style.top = `${triggerRect.bottom + window.scrollY + 8}px`;
            dropdown.style.left = `${triggerRect.left}px`;
            dropdown.style.width = `${dropdownWidth}px`;
            dropdown.style.display = 'block';
            dropdown.classList.remove('hidden');
            
            arrow.classList.add('rotate-180');
            trigger.classList.add('border-green-500');
        } else {
            closeDropdown();
        }
    };

    // Função para fechar dropdown
    const closeDropdown = () => {
        if (isOpen) {
            isOpen = false;
            dropdown.style.display = 'none';
            dropdown.classList.add('hidden');
            arrow.classList.remove('rotate-180');
            trigger.classList.remove('border-green-500');
        }
    };

    // Event listeners do dropdown
    if (trigger) {
        trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            toggleDropdown();
        });
    }

    // Fechar dropdown ao clicar fora
    document.addEventListener('click', (e) => {
        if (!dropdown.contains(e.target) && !trigger.contains(e.target)) {
            closeDropdown();
        }
    });

    // Event listeners para quartos
    if (quartosMinus) {
        quartosMinus.addEventListener('click', (e) => {
            e.stopPropagation();
            if (quartos > 1) {
                quartos--;
                updateValues();
            }
        });
    }

    if (quartosPlus) {
        quartosPlus.addEventListener('click', (e) => {
            e.stopPropagation();
            if (quartos < 10) {
                quartos++;
                updateValues();
            }
        });
    }

    // Event listeners para adultos
    if (adultosMinus) {
        adultosMinus.addEventListener('click', (e) => {
            e.stopPropagation();
            if (adultos > 1) {
                adultos--;
                updateValues();
            }
        });
    }

    if (adultosPlus) {
        adultosPlus.addEventListener('click', (e) => {
            e.stopPropagation();
            if (adultos < 20) {
                adultos++;
                updateValues();
            }
        });
    }

    // Event listeners para crianças
    if (criancasMinus) {
        criancasMinus.addEventListener('click', (e) => {
            e.stopPropagation();
            if (criancas > 0) {
                criancas--;
                updateValues();
            }
        });
    }

    if (criancasPlus) {
        criancasPlus.addEventListener('click', (e) => {
            e.stopPropagation();
            if (criancas < 10) {
                criancas++;
                updateValues();
            }
        });
    }

    // Prevenir que clicks dentro do dropdown fechem ele
    if (dropdown) {
        dropdown.addEventListener('click', (e) => {
            e.stopPropagation();
        });
    }

    // Inicializar valores
    updateValues();
};
